module.exports = require('projects/' + process.env.REACT_APP_PROJECT + '/entry')



// WEBPACK FOOTER //
// ./src/flow.js